class Video {
  init() {
    this.videos = document.querySelectorAll('[data-video] video');
    this.initBindings();
  }

  initBindings() {
    Array.from(this.videos).forEach((video) => {
      video.addEventListener('click', this.onClick.bind(this));
    });
  }

  onClick(e) {
    Array.from(this.videos).forEach((video) => {
      if (video !== e.target) video.pause();
    });

    if (e.target.paused) {
      e.target.play();
    } else {
      e.target.pause();
    }
  }
}

export const videoController = new Video();



// WEBPACK FOOTER //
// ./scripts/modules/video.js